import React from "react";
import { Container, Button, Alert } from "react-bootstrap";
import NewHireKitItem from "./NewHireKitItem";

/**
 * Post-order confirmation for New Hire Kits (no pricing shown).
 */
const NewHireKitOrderConfirmation = ({
  order,
  items,
  address,
  polybagChecked,
  polybagLabel,
  onDone,
  doneLabel
}) => {
  return (
    <Container className="py-3">
      <Alert variant="success">
        <Alert.Heading>New Hire Kit order placed</Alert.Heading>
        <p className="mb-0">
          Order <strong>#{order?.id}</strong> has been submitted.
          A confirmation email has been sent to your account (without pricing).
        </p>
      </Alert>

      <h2>Order #{order?.id}</h2>

      {address && (
        <div className="mb-4">
          <h4>Delivering to {address.name}</h4>
          <p style={{ marginLeft: 30, padding: 5, border: "1px solid #CCCCCC" }}>
            {address.street}<br />
            {address.street2 != null && address.street2 !== "" && <>{address.street2}<br /></>}
            {address.city}, {address.state} {address.zip || address.zipCode}<br />
            {polybagChecked && (
              <>Polybag Packaging{polybagLabel ? <> with Label: <strong>{polybagLabel}</strong></> : null}<br /></>
            )}
          </p>
        </div>
      )}

      <h4>Items</h4>
      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {(items || []).map((entry, idx) => (
          <li key={idx}>
            <NewHireKitItem
              item={entry.item}
              inventory={null}
              setSize={null}
              remove={null}
              edit={false}
              currentSize={entry.selectedSize}
            />
          </li>
        ))}
      </ul>

      <Button variant="primary" onClick={onDone} style={{ marginTop: 20 }}>
        {doneLabel || "Place Another Kit Order"}
      </Button>
    </Container>
  );
};

export default NewHireKitOrderConfirmation;
